<template>
  <section
    :class="[
      cardClass,
      overflowHidden ? 'overflow-hidden' : '',
      selectable ? 'select-none' : '',
    ]"
  >
    <div
      v-if="title || $slots.header"
      class="flex items-center justify-between gap-3 border-b px-4 py-3"
      :class="edgeClass"
    >
      <div class="min-w-0">
        <h3 :class="['text-sm font-semibold', titleClass]">
          {{ title }}
        </h3>
        <p v-if="description" :class="['mt-0.5 text-xs', descriptionClass]">
          {{ description }}
        </p>
      </div>
      <div class="flex shrink-0 items-center gap-2">
        <slot name="header"/>
      </div>
    </div>

    <div :class="[flush ? '' : 'px-4 py-4', bodyClass]">
      <slot/>
    </div>

    <div
      v-if="$slots.footer"
      class="border-t p-3"
      :class="edgeClass"
    >
      <slot name="footer"/>
    </div>
  </section>
</template>

<script setup lang="ts">
/**
 * Self-contained card chrome. Defaults = classic product solid look.
 * Pass class props to restyle (e.g. admin skins) — no theme inject required.
 */
withDefaults(defineProps<{
  title?: string
  description?: string
  flush?: boolean
  overflowHidden?: boolean
  selectable?: boolean
  bodyClass?: string
  /** Outer card surface (border / fill / radius / shadow). */
  cardClass?: string
  /** Header/footer divider + border color utility. */
  edgeClass?: string
  /** Title text color. */
  titleClass?: string
  /** Description text color. */
  descriptionClass?: string
}>(), {
  flush: false,
  overflowHidden: false,
  selectable: false,
  bodyClass: '',
  cardClass:
    'rounded-xl border border-stone-200 bg-white shadow-xs dark:border-stone-700 dark:bg-zinc-900',
  edgeClass: 'border-stone-200 dark:border-stone-700',
  titleClass: 'text-stone-900 dark:text-stone-100',
  descriptionClass: 'text-stone-500 dark:text-stone-400',
})
</script>
